import React, { useCallback } from 'react'
import tw from 'twin.macro'
import { useWagmi } from 'libs/wagmi'
import { useTranslation } from 'contexts/Localization'
import { Link } from '@nominex/dex-uikit'
import { SlInput } from '@shoelace-style/shoelace/dist/react'
import { getBlockExplorerLink, getBlockExplorerName, isAddress } from 'utils'
import { RowBetween } from 'components/Layout'

const SelectionPanel = tw.div`
  relative z-[1]
`

const Container = tw.div`
  flex flex-col flex-nowrap p-16 gap-8 rounded-12 bg-dark-gray/50 shadow-[0_2px_2px_-1px_rgba(74, 74, 104, 0.1)]
`

export default function AddressInputPanel({
  id,
  value,
  onChange,
}: {
  id?: string
  value: string
  onChange: (value: string) => void
}) {
  const { chainId } = useWagmi()

  const { t } = useTranslation()
  const address = isAddress(value) ? value : null

  const handleInput = useCallback((e: any) => onChange(e.target.value.replace(/\s+/g, '')), [onChange])

  const error = Boolean(value.length > 0 && !address)

  return (
    <SelectionPanel id={id}>
      <Container>
        <RowBetween>
          <div className="text-primary">{t('Recipient')}</div>
          {address && chainId && (
            <Link external small href={getBlockExplorerLink(address, 'address', chainId)}>
              (
              {t('View on %site%', {
                site: getBlockExplorerName(chainId),
              })}
              )
            </Link>
          )}
        </RowBetween>
        <SlInput
          className="recipient-address-input"
          type="text"
          autocomplete="off"
          autocorrect="off"
          autocapitalize="off"
          placeholder={t('Wallet address')}
          invalid={error}
          pattern="^(0x[a-fA-F0-9]{40})$"
          onSlInput={handleInput}
          value={value}
        />
      </Container>
    </SelectionPanel>
  )
}
